import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../translations";

export const LanguageSwitcher = () => {
  const { language, toggleLanguage } = useLanguage();

  const buttonText =
    language === "en"
      ? translations[language]["switchToChinese"]
      : translations[language]["switchToEnglish"];

  return (
    <button onClick={toggleLanguage} className="language-switcher">
      {language === "en" ? "切换到中文" : "Switch to English"}
    </button>
  );
};
